import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

export const AvatarIcon = ( props ) => {

    // Build the contents of the icon depending on the incomming props.
    const contents = useMemo( () => {
        // Validate prop data.
        const isValidUsername = Boolean( props.username );
        const isValidImage = Boolean( props.imageUrl );

        if ( isValidImage ) {
            // If an image is provided, always render the image. The image will be
            // centered and will fill the icon.
            return (
                <div
                    className="avatar-icon-content-image"
                    style={ { backgroundImage: `url(${ props.imageUrl })` } }
                />
            );
        } else if ( isValidUsername ) {
            // Using username provided, attempt to determine which letters to display
            // in the avatar icon to accurately represent the username.
            const tokens = props.username.split( ' ' );
            const abbr = ( tokens.length === 2 )
                ? ( tokens[ 0 ][ 0 ] + tokens[ 1 ][ 0 ] )
                : tokens[ 0 ][ 0 ];

            return (
                <span className="name-abbr">{ abbr }</span>
            );
        } else {
            return props.children;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ props.username, props.imageUrl ] );

    // Construct the classes to use for the component root.
    const rootClasses = classNames(
        'avatar-icon',
        { 'large': props.large },
        { 'small': !props.large },
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <div aria-label={ props.username } className={ rootClasses } style={ props.style }>
            <div className="avatar-icon-content">
                { contents }
            </div>
        </div>
    );
};

/**
 * The default properties used for this component if values aren't given
 * to the component externally.
 */
AvatarIcon.defaultProps = {
    className: undefined,
    style: undefined,

    username: '',
    imageUrl: undefined,
    large: false,
};

/**
 * The type definitions of the properties this component accepts.
 */
AvatarIcon.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,

    username: PropTypes.string,
    imageUrl: PropTypes.string,
    large: PropTypes.bool,
};
